module.exports = require("morgan");


/*****************
 ** WEBPACK FOOTER
 ** external "morgan"
 ** module id = 9
 ** module chunks = 0
 **/